// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

/* eslint-disable */

/**
 * This is a automatically generated component, do not edit it.
 * If you need to edit this component, move it to some other folder.
 */

import React from 'react';
function DrugIcon15(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <g
        fill="currentColor"
        clipPath="url(#a)"
      >
        <path d="M21.666 23.69a.334.334 0 0 0 .237-.1l1.696-1.697a.334.334 0 0 0 0-.47.333.333 0 0 0-.47 0l-1.696 1.697a.333.333 0 0 0 .233.57Z" />
        <path d="m31.827 26.8-1.117-1.62a.999.999 0 0 0-1.51-.137l-.59.59-.867-1.47c.2-3.556.22-3.36.124-3.496-.04-.06-14.2-18.527-14.307-18.627-.107-.1.107.097-1.933-1.943a.332.332 0 0 0-.474 0L.097 11.153a.334.334 0 0 0 0 .474c2.04 2.04 1.866 1.87 1.943 1.933.077.063 18.347 14.107 18.627 14.303.136.1-.097.08 3.5-.12l1.47.867-.594.59a1 1 0 0 0 .137 1.51l1.62 1.117a1 1 0 0 0 1.257-.117l3.666-3.667a1 1 0 0 0 .104-1.243ZM1.913 10.283c.62.617.63.667.81.667a.333.333 0 0 0 .234-.57l-.574-.57 1.504-1.503c.62.62.63.666.81.666a.333.333 0 0 0 .236-.57L4.36 7.83l1.503-1.497c.617.62.63.667.807.667a.333.333 0 0 0 .237-.567l-.574-.57L7.837 4.36c.62.617.63.667.81.667a.333.333 0 0 0 .236-.57l-.576-.574L9.81 2.38c.62.62.63.667.81.667a.333.333 0 0 0 .237-.57l-.574-.564L11.39.803l1.45 1.454L2.257 12.84.803 11.39l1.11-1.107ZM18.46 16.95l2.5 2.503a.707.707 0 0 1 0 1l-.5.5a.72.72 0 0 1-1 0l-2.503-2.5a3.483 3.483 0 0 0 1.503-1.496v-.007Zm-.423-.713a2.782 2.782 0 0 1-1.787 1.786 2.793 2.793 0 1 1 1.793-1.793l-.006.007ZM12.3 13.8 7.27 8.77l1.5-1.5 5.03 5.03a3.45 3.45 0 0 0-1.5 1.5ZM6.797 9.243l5.243 5.24a3.456 3.456 0 0 0 4.233 4.237L19 21.433a1.377 1.377 0 0 0 1.947 0c.496-.496.9-.79.9-1.473a1.367 1.367 0 0 0-.414-.96l-2.713-2.713a3.457 3.457 0 0 0-4.237-4.234l-5.24-5.256L13.28 2.76l13.873 18.067-6.333 6.333L2.76 13.28l4.037-4.037Zm20.416 12.464-.136 2.393-2.977 2.977-2.393.136 5.506-5.506Zm.12 3.076.787 1.334-2 2-1.333-.787 2.546-2.547Zm3.904 2.8L27.57 31.25a.313.313 0 0 1-.403.037l-1.624-1.117a.334.334 0 0 1-.03-.503l4.154-4.154a.335.335 0 0 1 .486.044l1.117 1.623a.313.313 0 0 1-.03.403h-.003Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path
            fill="#fff"
            d="M0 0h32v32H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export default DrugIcon15;
